import axios from 'axios'
import router from '@/router/routers'
import { Notification } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Config from '@/settings'
import Cookies from 'js-cookie'
import { message } from 'ant-design-vue'

import qs from 'qs'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? '/' : process.env.VUE_APP_BASE_API, // api 的 base_url
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: Config.timeout, // 请求超时时间
  paramsSerializer: params => {
    return qs.stringify(params, { indices: false })
  }// 这个方法主要是针对get请求的一个封装，让get请求传过来的params如果有数组例如：{ids:[1,2,3]} 会变成ids=1&ids=2&ids=3
})
// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    // REQUEST_SCOPE_INJECT_QMFM
    _injectRequestScope(config)
    const projectCode = store.getters.project && store.getters.project.code
    if (projectCode) {
      config.headers['x-project-code'] = projectCode
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.config && error.config.hideError) {
      return Promise.reject(error)
    }
    // 兼容blob下载出错json提示
    console.log('error.response: ', error.response)
    if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
      const reader = new FileReader()
      reader.readAsText(error.response.data, 'utf-8')
      reader.onload = function(e) {
        const errorMsg = JSON.parse(reader.result).message
        Notification.error({
          title: errorMsg,
          duration: 5000
        })
      }
    } else {
      let code = 0
      try {
        code = error.response.data.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          })
          return Promise.reject(error)
        }
      }
      if (code) {
        if (code === 401) {
          store.dispatch('LogOut').then(() => {
            // 用户登录界面提示
            Cookies.set('point', 401)
            location.reload()
          })
        } else if (code === 403) {
          router.push({ path: '/401' })
        } else {
          const errorMsg = error.response.data.message
          if (errorMsg !== undefined) {
            Notification.error({
              title: errorMsg,
              duration: 5000
            })
          }
        }
      } else {
        Notification.error({
          title: '接口请求失败',
          duration: 5000
        })
      }
    }
    return Promise.reject(error)
  }
)

/**
 * 导出文件
 * @param {object} data
 */
function download(url, data = {}, filename = '导出文件', method = 'post') {
  // downloadLoadingInstance = Loading.service({ text: '正在导出数据，请稍候...', spinner: 'el-icon-loading' })
  return service({
    url,
    method,
    responseType: 'blob',
    data,
    params: method === 'get' ? data : null,
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    },
    onDownloadProgress: e => {
      console.log('e: ', e.loaded)
      console.log(e.total, '111')
    }
  }).then(res => {
    console.log('res: ', res)
    // // 文件流自动下载
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    // 动态名称
    downloadElement.download = `${filename || '统计报表'}`
    document.body.appendChild(downloadElement)
    downloadElement.click()
    window.URL.revokeObjectURL(href)
    document.body.removeChild(downloadElement)
    message.success('导出成功！')
    // downloadLoadingInstance.close()
  }).catch(error => {
    // downloadLoadingInstance.close()
    message.error('导出文件出现错误，请联系管理员！')
    console.log('error: ', error)
  })
}

const getModuleParams = () => {
  const path = router.app._route.path
  let module = null
  if (path.indexOf('qm') !== -1 || path.indexOf('QM') !== -1) {
    module = 'QM'
  }
  if (path.indexOf('fm') !== -1 || path.indexOf('FM') !== -1) {
    module = 'FM'
  }
  return module
}

const _injectRequestScope = (config) => {
  console.log('------_injectRequestScope----------', config)
  console.log('------QM/FM判断是否要加module参数getModuleParams----------', getModuleParams())
  // REQUEST_SCOPE_INJECT_QMFM
  if (config.REQUEST_SCOPE_INJECT_QMFM === 1 && getModuleParams()) {
    config.params = {
      ...(config.params || {}),
      module: getModuleParams()
    }
    if (
      config.data &&
      !(config.data instanceof FormData)
    ) {
      config.data = {
        ...config.data,
        module: getModuleParams()
      }
    } else if (!config.data) {
      config.data = {
        module: getModuleParams()
      }
    }
  }
}

export default service

export {
  download,
  getModuleParams
}
